import { render, staticRenderFns } from "./EstimationsSimpleList.vue?vue&type=template&id=b5205654&scoped=true"
import script from "./EstimationsSimpleList.vue?vue&type=script&lang=js"
export * from "./EstimationsSimpleList.vue?vue&type=script&lang=js"
import style0 from "./EstimationsSimpleList.vue?vue&type=style&index=0&id=b5205654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5205654",
  null
  
)

export default component.exports